
import React from 'react';
import Layout from '@/components/Layout';

const CheckoutCancelPage: React.FC = () => {
  return (
    <Layout>
      <div className="container py-10">
        <h1 className="text-3xl font-bold">Payment Cancelled</h1>
        <p className="mt-4">Your payment has been cancelled.</p>
      </div>
    </Layout>
  );
};

export default CheckoutCancelPage;
